import { useEffect, useState } from 'preact/hooks';
import { currentLocale, localeVersion, subscribe } from './index';

/** Re-render the calling component when the language changes; returns the active locale code. */
export function useI18n(): string {
  const [, setV] = useState(localeVersion());
  useEffect(() => subscribe(() => setV(localeVersion())), []);
  return currentLocale();
}
